import app from '../../forum/app';
import Component from '../../common/Component';
import Link from '../../common/components/Link';
import username from '../../common/helpers/username';
import userOnline from '../../common/helpers/userOnline';
import listItems from '../../common/helpers/listItems';
import Avatar from '../../common/components/Avatar';
/**
 * The `PostUser` component shows the avatar and username of a post's author.
 */
export default class PostUser extends Component {
  view() {
    const post = this.attrs.post;
    const user = post.user();
    if (!user) {
      return m("div", {
        className: "PostUser"
      }, m("h3", {
        className: "PostUser-name"
      }, m(Avatar, {
        user: user,
        className: "Post-avatar"
      }), " ", username(user)));
    }
    return m("div", {
      className: "PostUser"
    }, m("h3", {
      className: "PostUser-name"
    }, m(Link, {
      href: app.route.user(user)
    }, m(Avatar, {
      user: user,
      className: "Post-avatar"
    }), userOnline(user), username(user))), m("ul", {
      className: "PostUser-badges badges badges--packed"
    }, listItems(user.badges().toArray())));
  }
}
flarum.reg.add('core', 'forum/components/PostUser', PostUser);